import React from "react";
import Header from "../src/components/Header";
import Footer from "../src/components/Footer";
import { Container } from 'react-bootstrap'
import {BrowserRouter as Router, Route } from 'react-router-dom';
import HomeScreen from "./screens/HomeScreen";
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import IzvestajiScreen from './screens/IzvestajiScreen'
import KvarScreen from './screens/KvarScreen'
import LandingScreen from "./screens/LandingScreen";
import AzuriranjeScreen from './screens/AzuriranjeScreen';
// import UserListScreen from './screens/UserListScreen'
// import UserEditScreen from './screens/UserEditScreen'

function App() {
  // api-key = AIzaSyACV2yMJcx_aByY3PwY1b59WvppbM9_ovc
  return (
    <Router>
      <Header />
      <main className="py-3">
        <Container>
          <Route path='/' component={LandingScreen} exact />
         <Route path='/home/:id' component={HomeScreen} />
        <Route path="/login" component={LoginScreen} />
        <Route path="/register" component={RegisterScreen} />
        <Route path="/admin/izvestaji" component={IzvestajiScreen} />
        <Route path='/admin/istorija' component={KvarScreen} />
        <Route path="/azuriranje" component={AzuriranjeScreen} />
        </Container>
      </main>
      <Footer />
      </Router>
  );
}

export default App;

